import React from 'react';
import { Lock, Zap, ShieldCheck, CreditCard, Mail, BookOpen } from 'lucide-react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export const FinalCTA = () => {
  return <Section background="cream" className="py-16 md:py-24 border-t border-stone-200" data-id="element-71">
      <div className="max-w-3xl mx-auto text-center" data-id="element-72">
        <div className="mb-8" data-id="element-73">
          <p className="text-red-600 font-bold text-sm uppercase tracking-widest mb-4" data-id="element-74">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <div className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-xl shadow-sm border border-stone-200 font-heading font-extrabold text-2xl text-stone-900" data-id="element-75">
            <span className="text-red-500" data-id="element-76">🔴</span> 23 hs : 59 min : 47 seg
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-stone-900 mb-10" data-id="element-77">
          ÚLTIMA OPORTUNIDAD ELEGÍ TU KIT!
        </h2>

        <Button href="https://www.tufenixdigital.store" variant="secondary" size="xl" className="w-full sm:w-auto mb-10 text-lg shadow-xl shadow-celeste-500/20" data-id="element-78">
          QUIERO MI KIT AULA DE ÉXITOS AHORA!
        </Button>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm font-medium text-stone-600 bg-white p-6 rounded-2xl border border-stone-100 shadow-sm" data-id="element-79">
          <div className="flex items-center justify-center gap-2" data-id="element-80">
            <Lock className="w-4 h-4 text-stone-400" data-id="element-81" /> Pago 100% seguro
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-82">
            <Zap className="w-4 h-4 text-amber-500" data-id="element-83" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-84">
            <ShieldCheck className="w-4 h-4 text-emerald-500" data-id="element-85" /> Garantía 7 días
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-86">
            <CreditCard className="w-4 h-4 text-stone-400" data-id="element-87" /> Mercado Pago
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-88">
            <span className="text-base leading-none" data-id="element-89">🇺🇾</span> Hecho en Uruguay
            · Para Uruguay
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-90">
            <BookOpen className="w-4 h-4 text-celeste-500" data-id="element-91" /> 100% adaptado EBI
          </div>
        </div>
      </div>
    </Section>;
};